/// <amd-module name="Wit/Settings/BoardsExternalIntegration/components/panels/FirstRunExperience/FirstRunExperiencePanelStaticContent" />
import * as React from "react";
import { VssComponent, IVssComponentContext } from "VSS/Platform/Layout";
import { getAssetLocation } from "VSS/Platform/Location";
import { Link } from "VSSUI/Link";
import { DocUrls } from "Wit/Settings/BoardsExternalIntegration/constants/Constants";
import * as Resources from "Wit/Settings/BoardsExternalIntegration/Resources";

const FirstRunExperienceStaticContentImage =
    "ms.vss-work-web/boards-external-integration-content/assets/GitHub_App_FRE_Panel_Static_Content_Image.png";

export class FirstRunExperiencePanelStaticContent extends VssComponent {
    private _panelImageSource: string;

    constructor(props: never, context: IVssComponentContext) {
        super(props, context);

        this._panelImageSource = getAssetLocation(this.context.pageContext, FirstRunExperienceStaticContentImage);
    }

    public render(): JSX.Element {
        return (
            <div className="static-content">
                <span className="quick-start-title title-xs">{Resources.FirstRunExperience_StaticContent_QuickStart_Title}</span>
                <span className="quick-start-content body-m">
                    {Resources.FirstRunExperience_StaticContent_QuickStart_Content_Part1}
                    <span className="mention-sample">{'"AB#"'}</span>
                    {Resources.FirstRunExperience_StaticContent_QuickStart_Content_Part2}
                    <Link className="link-pull-request-doc" target="_blank" href={DocUrls.GitHubAndAzureBoards_LinkPullRequest}>
                        {Resources.FirstRunExperience_StaticContent_QuickStart_Content_LinkText}
                    </Link>
                    {Resources.FirstRunExperience_StaticContent_QuickStart_Content_Part3}
                </span>
                <img className="panel-image" src={this._panelImageSource} />
            </div>
        );
    }
}
